<template>
	<div class="pagination">
		<button @click="goToFirst" :disabled="currentPage === 1" class="page-btn">
			首页
		</button>
		<!-- <button @click="goToPrev" :disabled="currentPage === 1" class="page-btn">
			上一页
		</button> -->
		<!-- 第一页 -->
		<button v-if="showFirstPage&&showFrontEllipsis" @click="goToPage(1)" :class="{ active: currentPage === 1 }" class="page-btn">
			1
		</button>
		<!-- 前省略号 -->
		<span v-if="showFrontEllipsis" class="ellipsis">...</span>
		<!-- 中间页码 -->
		<button v-for="page in middlePages" :key="page" @click="goToPage(page)" :class="{ active: currentPage === page }"
			class="page-btn">
			{{ page }}
		</button>
		<!-- 后省略号 -->
		<span v-if="showRearEllipsis" class="ellipsis">...</span>
		<!-- 最后一页 -->
		<button v-if="showLastPage&&showRearEllipsis" @click="goToPage(totalPages)" :class="{ active: currentPage === totalPages }" class="page-btn">
			{{ totalPages }}
		</button>
		<!-- <button @click="goToNext" :disabled="currentPage === totalPages" class="page-btn">
			下一页
		</button> -->
		<button @click="goToLast" :disabled="currentPage === totalPages" class="page-btn">
			尾页
		</button>
		<!-- <div class="total-pages">共 {{ totalNum }} 条</div> -->
	</div>
</template>
  
  <script>
export default {
	props: {
		totalPages: {
			type: Number,
			required: true,
			default: 1
		},
		currentPage: {
			type: Number,
			required: true,
			default: 1
		},
		maxVisiblePages: {
			type: Number,
			default: 3
		},
        totalNum: {
			type: Number,
			required: true,
			default: 1
		},
	},

	computed: {
		showFrontEllipsis() {
			return this.totalPages > this.maxVisiblePages &&
				this.currentPage > Math.ceil(this.maxVisiblePages / 2)
		},

		showRearEllipsis() {
			return this.totalPages > this.maxVisiblePages &&
				this.currentPage <= this.totalPages - Math.ceil(this.maxVisiblePages / 2)
		},

		showFirstPage() {
			return this.totalPages > this.maxVisiblePages &&
				(this.showFrontEllipsis || this.currentPage <= this.maxVisiblePages)
		},

		showLastPage() {
			return this.totalPages > this.maxVisiblePages &&
				(this.showRearEllipsis || this.currentPage > this.totalPages - this.maxVisiblePages)
		},

		middlePages() {
			if (this.totalPages <= this.maxVisiblePages) {
				return Array.from({ length: this.totalPages }, (_, i) => i + 1)
			}

			const half = Math.floor(this.maxVisiblePages / 2)
			let start = this.currentPage - half
			let end = this.currentPage + half

			if (start < 1) {
				end += Math.abs(start) + 1
				start = 1
			}

			if (end > this.totalPages) {
				start -= end - this.totalPages
				end = this.totalPages
			}

			start = Math.max(start, 1)
			end = Math.min(end, this.totalPages)

			// 处理边界情况
			if (end - start + 1 < this.maxVisiblePages) {
				if (this.currentPage <= half) {
					end = this.maxVisiblePages
				} else {
					start = this.totalPages - this.maxVisiblePages + 1
				}
			}

			return Array.from({ length: end - start + 1 }, (_, i) => start + i)
		}
	},

	methods: {
		goToFirst() {
			this.$emit('page-change', 1)
		},
		goToPrev() {
			this.$emit('page-change', Math.max(1, this.currentPage - 1))
		},
		goToPage(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.$emit('page-change', page)
			}
		},
		goToNext() {
			this.$emit('page-change', Math.min(this.totalPages, this.currentPage + 1))
		},
		goToLast() {
			this.$emit('page-change', this.totalPages)
		}
	}
}
  </script>
  
  <style scoped>
.pagination {
	display: flex;
	align-items: center;
	gap: 5px;
	margin: 15px 0 20px 0;
}

.page-btn {
	padding: 4px 9px;
	border: 1px solid #ddd;
	border-radius: 4px;
	background: white;
	cursor: pointer;
	transition: all 0.3s;
    font-size: 13px;
}

.page-btn:not(:disabled):hover {
	background: #f5f5f5;
}

.page-btn:disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.active {
	background: #004098 !important;
	color: white;
	border-color: #004098;
}

.ellipsis {
	padding: 0 6px;
	color: #666;
	user-select: none;
}

.total-pages {
	margin-left: 7px;
	color: #666;
}
</style>